var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ServiceService from '../../../api/ServiceService';
var PayDialog = (function (_super) {
    __extends(PayDialog, _super);
    function PayDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.qrcodePath = '';
        _this.order_id = null;
        _this.timer = null;
        return _this;
    }
    PayDialog.prototype.created = function () {
        var _this = this;
        this.service = ServiceService.getInstance();
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = setInterval(function () {
            _this.getPayFlag();
        }, 3000);
    };
    PayDialog.prototype.getPayFlag = function () {
        var _this = this;
        var params = { order_id: this.order_id };
        this.service.getPayFlag(params).then(function (res) {
            if (res.data.data.is_pay == 1) {
                _this.$closeDialog();
                clearInterval(_this.timer);
                _this.$emit('paySuccess');
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PayDialog.prototype.destroyed = function () {
        clearInterval(this.timer);
    };
    PayDialog = __decorate([
        Component
    ], PayDialog);
    return PayDialog;
}(VueDialog));
export default PayDialog;
